__turbopack_context__.v({
  "bundle-banner-section": "premium-module-scss-module__xJf22G__bundle-banner-section",
  "callout": "premium-module-scss-module__xJf22G__callout",
  "demo-phone": "premium-module-scss-module__xJf22G__demo-phone",
  "end-of-intro-pricing-countdown-and-warning": "premium-module-scss-module__xJf22G__end-of-intro-pricing-countdown-and-warning",
  "end-of-intro-pricing-hero": "premium-module-scss-module__xJf22G__end-of-intro-pricing-hero",
  "headline": "premium-module-scss-module__xJf22G__headline",
  "hero": "premium-module-scss-module__xJf22G__hero",
  "hero-image": "premium-module-scss-module__xJf22G__hero-image",
  "lead": "premium-module-scss-module__xJf22G__lead",
  "non-premium-country": "premium-module-scss-module__xJf22G__non-premium-country",
  "perk": "premium-module-scss-module__xJf22G__perk",
  "perks": "premium-module-scss-module__xJf22G__perks",
  "perks-wrapper": "premium-module-scss-module__xJf22G__perks-wrapper",
  "pill": "premium-module-scss-module__xJf22G__pill",
  "plan-comparison": "premium-module-scss-module__xJf22G__plan-comparison",
  "plans": "premium-module-scss-module__xJf22G__plans",
  "plans-wrapper": "premium-module-scss-module__xJf22G__plans-wrapper",
  "social-proof": "premium-module-scss-module__xJf22G__social-proof",
  "use-cases": "premium-module-scss-module__xJf22G__use-cases",
  "use-cases-wrapper": "premium-module-scss-module__xJf22G__use-cases-wrapper",
});
